import { FC, useEffect, useState } from "react";

import DoctorField from "./treatingReferringFields/doctorField";
import PracticeField from "./treatingReferringFields/practiceField";

import usePatientDetailFunc from "src/hooks/usePatientDetailFunc";
import useTreatingPracAndDocFunc from "src/hooks/useTreatingPracAndDocFunc";
import useReferringPracAndDocFunc from "src/hooks/useReferringPracAndDocFunc";

import { IOveraOnStepTwoProps } from "./types";
import AnesthesiologyGroup from "./treatingReferringFields/anesthesiology";
// import { isFieldRequired } from "src/helpers/addCase";
// import { CaseContext } from "src/context/caseContext";




const ORGUserOptions: FC<IOveraOnStepTwoProps> = ({ control, watch, setValue, trigger, getValues }): JSX.Element => {
  const [firstTreatedPractice] = useState(getValues("doctor_attributes.treating_practice_id"))
  const [firstTreatedDoctor] = useState(getValues("doctor_attributes.treating_doctor_id"))
  const [firstReferringPractice] = useState(getValues("doctor_attributes.referring_practice_id"))
  const [firstReferringDoctor] = useState(getValues("doctor_attributes.referring_doctor_id"))

  // const { caseSchema } = useContext(CaseContext)
  const iAm = watch("doctor_attributes.i_am");
  const globalPatientId = watch("patient_attributes.global_patient_id");
  const is_anesthesiologist = watch("doctor_attributes.is_anesthesiologist");

  const treatingPracticeId = watch("doctor_attributes.treating_practice_id")
  const treatingDoctorId = watch("doctor_attributes.treating_doctor_id")
  const referringPracticeId = watch("doctor_attributes.referring_practice_id")
  const referringDoctorId = watch("doctor_attributes.referring_doctor_id")
  // const submittingParactice = watch("doctor_attributes.submitting_practice_id")

  usePatientDetailFunc(globalPatientId, setValue, trigger, getValues)
  const {
    isPracAPILoading: treatingPracLoading,
    globalDoctorsApiResponse: treatingDocResponse,
    practiceListing: treatingPracticeListing,
    getPracticeListing: getTreatingPracListing,
    clearPracticeListing: clearTreatingPracListing,
    getDoctorListingByPracticeId,
    getDoctorListingByPracticeId: getTreatingDoctorListingByPracticeId,
    doctorPracListing, 
    // doctorPracLoading,
    getDebouncedDoctorPracListingByQuery: getDoctorPracListingByQuery,
  } = useTreatingPracAndDocFunc(getValues, watch, setValue)
  const {
    isPracAPILoading: referringPracLoading,
    globalDoctorsApiResponse: referringDocResponse,
    practiceListing: referringPracticeListing,
    getPracticeListing: getreferringPracListing,
    clearPracticeListing: clearReferringPracListing,
    getReferringDoctorListingByPracticeId,
  } = useReferringPracAndDocFunc(getValues, watch, setValue)

  useEffect(() => {
    if (treatingPracticeId) {
      const selectedPractice = treatingPracticeListing?.data.find((prac) => prac.id === treatingPracticeId)
      if (iAm && iAm === 'Referring and Treating Facility') setValue("doctor_attributes.referring_practice_id", treatingPracticeId) 
      if (selectedPractice) setValue("practice_name", `${selectedPractice.name}${selectedPractice.address ? ` - ${selectedPractice.address.full_address}` : ''}`)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [treatingPracticeId])

  useEffect(() => {
    if (treatingDoctorId) {
      const selectedDoctor = treatingDocResponse?.data.find((doc) => doc.id === treatingDoctorId)
      if (selectedDoctor) {
        setValue("doctor_fullname", selectedDoctor.fullname)
        setValue("doctor_firstlastname", selectedDoctor.first_last_name)
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [treatingDoctorId])

  // useEffect(()=>{
    
        
  //   if (["Treating Facility"].includes(iAm)) {
  //     setValue("doctor_attributes.treating_practice_id",getValues("doctor_attributes.submitting_practice_id"))
  //   } else if (["Referring Facility", "Referring Provider"].includes(iAm)) {
  //       getTreatingPracListing("_", true)
  //       getreferringPracListing("", true)
  //       setValue("doctor_attributes.referring_practice_id",getValues("doctor_attributes.submitting_practice_id"))
  //     }

  // // eslint-disable-next-line react-hooks/exhaustive-deps
  // },[submittingParactice,iAm])
   
  // useEffect(()=>{
  //   setValue("doctor_attributes.submitting_practice_id",0)

  // // eslint-disable-next-line react-hooks/exhaustive-deps
  // },[iAm])

  useEffect(() => {
    if (iAm) {
      if (["Treating Facility"].includes(iAm)) {
        getreferringPracListing("_", true)
        getTreatingPracListing("", true)
        setValue("doctor_attributes.treating_practice_id",getValues("doctor_attributes.submitting_practice_id"))
      } else if (["Treating Provider"].includes(iAm) ){
        getreferringPracListing("_", true)
        getTreatingPracListing("_", true)
      }
      // else if (["Referring Provider"].includes(iAm)) {
      //   getTreatingPracListing("_", true)
      //   getreferringPracListing("", true)
      // } 
      else if ([ "Referring Facility","Referring Provider"].includes(iAm)) {
        getTreatingPracListing("_", true)
        getreferringPracListing("", true)
        setValue("doctor_attributes.referring_practice_id",getValues("doctor_attributes.submitting_practice_id"))
      }
      else {
        getTreatingPracListing("", true)
        getreferringPracListing("", true)
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [iAm,treatingPracticeId,referringPracticeId]);

    useEffect(() => {
    if (iAm === "Referring and Treating Facility") {
      if (treatingDoctorId !== 0 && referringPracticeId !== 0) {
        setValue("doctor_attributes.referring_doctor_id",treatingDoctorId)
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [iAm, treatingDoctorId, referringPracticeId])

  useEffect(() => {
    if (typeof is_anesthesiologist === "boolean") {
      if (is_anesthesiologist) {
        getDoctorPracListingByQuery(iAm !== "Treating Provider" ? "_" : "", true)
      } else {
        getTreatingDoctorListingByPracticeId(["Treating Provider"].includes(iAm) ? 0 : treatingPracticeId)
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [is_anesthesiologist])

  let fields = <></>;
  switch(iAm) {
    case "Treating Provider":
      fields = (
        <>
          {getValues("doctor_attributes.submitting_practice_id") ? (
            <>
              <AnesthesiologyGroup control={control} />
              {is_anesthesiologist === true ? (
                <PracticeField
                  mode="treating_provider_2"
                  shouldReset={treatingDoctorId !== firstTreatedDoctor}
                  shouldBeAbleToSearch={true}
                  isAPILoading={treatingPracLoading}
                  control={control}
                  fieldName="doctor_attributes.treating_doctor_id"
                  getPracticeListing={getDoctorPracListingByQuery}
                  pracListing={doctorPracListing}
                  setValue={setValue}
                  watch={watch}
                  isCancellable={true}
                  trigger={trigger}
                />
              ) : (
                <DoctorField
                  mode="treating_provider_3"
                  shouldReset={firstTreatedDoctor !== treatingDoctorId}
                  control={control}
                  fieldName="doctor_attributes.treating_doctor_id"
                  isRequired={true}
                  docListing={treatingDocResponse}
                  practice_id={getValues("doctor_attributes.treating_practice_id")}
                  setValue={setValue}
                  getDoctorListingByPracticeId={getDoctorListingByPracticeId}
                  watch={watch}
                  trigger={trigger}
                />
              )}
            </>
          )
          : null}
          <PracticeField
            mode="treating_provider_1"
            shouldReset={firstTreatedPractice !== treatingPracticeId}
            shouldBeAbleToSearch={true}
            isAPILoading={treatingPracLoading}
            control={control}
            fieldName="doctor_attributes.treating_practice_id"
            getPracticeListing={getTreatingPracListing}
            pracListing={treatingPracticeListing}
            clearPracListing={clearTreatingPracListing}
            dontResetDoctorField={true}
            setValue={setValue}
            watch={watch}
            trigger={trigger}
          />
          <PracticeField
            mode="treating_provider_4"
            shouldReset={firstReferringPractice !== referringPracticeId}
            shouldBeAbleToSearch={true}
            isAPILoading={referringPracLoading}
            control={control}
            fieldName="doctor_attributes.referring_practice_id"
            getPracticeListing={getreferringPracListing}
            pracListing={referringPracticeListing}
            clearPracListing={clearReferringPracListing}
            setValue={setValue}
            isCancellable={true}
            watch={watch}
            trigger={trigger}
          />
          {getValues("doctor_attributes.referring_practice_id") ?
            <DoctorField
              mode="treating_provider_5"
              shouldReset={firstReferringDoctor !== referringDoctorId}
              control={control}
              fieldName="doctor_attributes.referring_doctor_id"
              isRequired={true}
              docListing={referringDocResponse}
              practice_id={getValues("doctor_attributes.referring_practice_id")}
              setValue={setValue}
              getDoctorListingByPracticeId={getReferringDoctorListingByPracticeId}
              watch={watch}
              trigger={trigger}
            />
          : null}
        </>
      )
      break;
    case "Treating Facility":
      fields = (
        <>
          {/* <PracticeField
            mode="treating_facility_1"
            shouldReset={firstTreatedPractice !== treatingPracticeId}
            shouldBeAbleToSearch={false}
            isAPILoading={treatingPracLoading}
            control={control}
            fieldName="doctor_attributes.treating_practice_id"
            getPracticeListing={getTreatingPracListing}
            pracListing={treatingPracticeListing}
            setValue={setValue}
            watch={watch}
            trigger={trigger}
          /> */}
          {getValues("doctor_attributes.treating_practice_id") ?
            <>
              <AnesthesiologyGroup control={control} />
              {is_anesthesiologist === true ? (
                <PracticeField
                  mode="treating_facility_2"
                  shouldReset={treatingDoctorId !== firstTreatedDoctor}
                  shouldBeAbleToSearch={true}
                  isAPILoading={treatingPracLoading}
                  control={control}
                  fieldName="doctor_attributes.treating_doctor_id"
                  getPracticeListing={getDoctorPracListingByQuery}
                  pracListing={doctorPracListing}
                  setValue={setValue}
                  watch={watch}
                  isCancellable={true}
                  trigger={trigger}
                />
              ) : (
                <DoctorField
                  mode="treating_facility_3"
                  shouldReset={firstTreatedDoctor !== treatingDoctorId}
                  control={control}
                  fieldName="doctor_attributes.treating_doctor_id"
                  isRequired={true}
                  docListing={treatingDocResponse}
                  practice_id={getValues("doctor_attributes.treating_practice_id")}
                  setValue={setValue}
                  getDoctorListingByPracticeId={getDoctorListingByPracticeId}
                  watch={watch}
                  trigger={trigger}
                />
              )}
            </>
          : null}
          <PracticeField
            mode="treating_facility_4"
            shouldReset={firstReferringPractice !== referringPracticeId}
            shouldBeAbleToSearch={true}
            isAPILoading={referringPracLoading}
            control={control}
            fieldName="doctor_attributes.referring_practice_id"
            getPracticeListing={getreferringPracListing}
            pracListing={referringPracticeListing}
            clearPracListing={clearReferringPracListing}
            setValue={setValue}
            isCancellable={true}
            watch={watch}
            trigger={trigger}
          />
          {getValues("doctor_attributes.referring_practice_id") ?
            <DoctorField
              mode="treating_facility_5"
              shouldReset={firstReferringDoctor !== referringDoctorId}
              control={control}
              fieldName="doctor_attributes.referring_doctor_id"
              isRequired={true}
              docListing={referringDocResponse}
              practice_id={getValues("doctor_attributes.referring_practice_id")}
              setValue={setValue}
              getDoctorListingByPracticeId={getReferringDoctorListingByPracticeId}
              watch={watch}
              trigger={trigger}
            />
          : null}
        </>
      )
      break;
    case "Referring Provider":
      fields = (
        <>
          {/* <PracticeField
            mode="referring_provider_1"
            shouldReset={firstReferringPractice !== referringPracticeId}
            shouldBeAbleToSearch={true}
            isAPILoading={referringPracLoading}
            control={control}
            fieldName="doctor_attributes.referring_practice_id"
            getPracticeListing={getreferringPracListing}
            pracListing={referringPracticeListing}
            setValue={setValue}
            watch={watch}
            trigger={trigger}
          /> */}
          {getValues("doctor_attributes.referring_practice_id") ?
            <DoctorField
              mode="referring_provider_3"
              shouldReset={firstReferringDoctor !== referringDoctorId}
              control={control}
              fieldName="doctor_attributes.referring_doctor_id"
              isRequired={true}
              docListing={referringDocResponse}
              practice_id={getValues("doctor_attributes.referring_practice_id")}
              setValue={setValue}
              getDoctorListingByPracticeId={getReferringDoctorListingByPracticeId}
              watch={watch}
              trigger={trigger}
            />
          : null}
          <PracticeField
            mode="referring_provider_2"
            shouldReset={firstTreatedPractice !== treatingPracticeId}
            shouldBeAbleToSearch={true}
            isAPILoading={treatingPracLoading}
            control={control}
            fieldName="doctor_attributes.treating_practice_id"
            getPracticeListing={getTreatingPracListing}
            pracListing={treatingPracticeListing}
            clearPracListing={clearTreatingPracListing}
            setValue={setValue}
            isCancellable={true}
            watch={watch}
            trigger={trigger}
          />
          {getValues("doctor_attributes.treating_practice_id") ?
            <>
              <AnesthesiologyGroup control={control} />
              {is_anesthesiologist === true ? (
                <PracticeField
                  mode="referring_provider_4"
                  shouldReset={treatingDoctorId !== firstTreatedDoctor}
                  shouldBeAbleToSearch={true}
                  isAPILoading={treatingPracLoading}
                  control={control}
                  fieldName="doctor_attributes.treating_doctor_id"
                  getPracticeListing={getDoctorPracListingByQuery}
                  pracListing={doctorPracListing}
                  setValue={setValue}
                  watch={watch}
                  isCancellable={true}
                  trigger={trigger}
                />
              ) : (
                <DoctorField
                  mode="referring_provider_5"
                  shouldReset={firstTreatedDoctor !== treatingDoctorId}
                  control={control}
                  fieldName="doctor_attributes.treating_doctor_id"
                  isRequired={true}
                  docListing={treatingDocResponse}
                  practice_id={getValues("doctor_attributes.treating_practice_id")}
                  setValue={setValue}
                  getDoctorListingByPracticeId={getDoctorListingByPracticeId}
                  watch={watch}
                  trigger={trigger}
                />
              )}
            </>
          : null}
        </>
      )
      break;
    case "Referring Facility":
      fields = (
        <>
          {/* <PracticeField
            mode="referring_facility_1"
            shouldReset={firstTreatedPractice !== treatingPracticeId}
            shouldBeAbleToSearch={false}
            isAPILoading={referringPracLoading}
            control={control}
            fieldName="doctor_attributes.referring_practice_id"
            getPracticeListing={getreferringPracListing}
            pracListing={referringPracticeListing}
            setValue={setValue}
            watch={watch}
            trigger={trigger}
          /> */}
          {getValues("doctor_attributes.referring_practice_id") ?
            <DoctorField
              mode="referring_facility_3"
              shouldReset={firstReferringDoctor !== referringDoctorId}
              control={control}
              fieldName="doctor_attributes.referring_doctor_id"
              isRequired={true}
              docListing={referringDocResponse}
              practice_id={getValues("doctor_attributes.referring_practice_id")}
              setValue={setValue}
              getDoctorListingByPracticeId={getReferringDoctorListingByPracticeId}
              watch={watch}
              trigger={trigger}
            />
          : null}
          <PracticeField
            mode="referring_facility_2"
            shouldReset={firstReferringPractice !== referringPracticeId}
            shouldBeAbleToSearch={true}
            isAPILoading={treatingPracLoading}
            control={control}
            fieldName="doctor_attributes.treating_practice_id"
            getPracticeListing={getTreatingPracListing}
            pracListing={treatingPracticeListing}
            clearPracListing={clearTreatingPracListing}
            setValue={setValue}
            isCancellable={true}
            watch={watch}
            trigger={trigger}
          />
          {getValues("doctor_attributes.treating_practice_id") ?
            <>
              <AnesthesiologyGroup control={control} />
              {is_anesthesiologist === true ? (
                <PracticeField
                  mode="referring_facility_4"
                  shouldReset={treatingDoctorId !== firstTreatedDoctor}
                  shouldBeAbleToSearch={true}
                  isAPILoading={treatingPracLoading}
                  control={control}
                  fieldName="doctor_attributes.treating_doctor_id"
                  getPracticeListing={getDoctorPracListingByQuery}
                  pracListing={doctorPracListing}
                  setValue={setValue}
                  watch={watch}
                  isCancellable={true}
                  trigger={trigger}
                />
              ) : (
                <DoctorField
                  mode="referring_facility_5"
                  shouldReset={firstTreatedDoctor !== treatingDoctorId}
                  control={control}
                  fieldName="doctor_attributes.treating_doctor_id"
                  isRequired={true}
                  docListing={treatingDocResponse}
                  practice_id={getValues("doctor_attributes.treating_practice_id")}
                  setValue={setValue}
                  getDoctorListingByPracticeId={getDoctorListingByPracticeId}
                  watch={watch}
                  trigger={trigger}
                />
              )}
            </>
          : null}
        </>
      )
      break;
    case "Referring and Treating Facility":
      fields = (
        <>
          <PracticeField
            mode="referring_and_treating_facility_1"
            shouldReset={firstTreatedPractice !== treatingPracticeId}
            shouldBeAbleToSearch={false}
            isAPILoading={treatingPracLoading}
            control={control}
            fieldName="doctor_attributes.treating_practice_id"
            getPracticeListing={getTreatingPracListing}
            pracListing={treatingPracticeListing}
            setValue={setValue}
            watch={watch}
            trigger={trigger}
          />
          {getValues("doctor_attributes.treating_practice_id") ?
            <>
              <AnesthesiologyGroup control={control} />
              {is_anesthesiologist === true ? (
                <PracticeField
                  mode="referring_and_treating_facility_2"
                  shouldReset={treatingDoctorId !== firstTreatedDoctor}
                  shouldBeAbleToSearch={true}
                  isAPILoading={treatingPracLoading}
                  control={control}
                  fieldName="doctor_attributes.treating_doctor_id"
                  getPracticeListing={getDoctorPracListingByQuery}
                  pracListing={doctorPracListing}
                  setValue={setValue}
                  watch={watch}
                  isCancellable={true}
                  trigger={trigger}
                />
              ) : (
                <DoctorField
                  mode="referring_and_treating_facility_3"
                  shouldReset={firstTreatedDoctor !== treatingDoctorId}
                  control={control}
                  fieldName="doctor_attributes.treating_doctor_id"
                  isRequired={true}
                  docListing={treatingDocResponse}
                  practice_id={getValues("doctor_attributes.treating_practice_id")}
                  setValue={setValue}
                  getDoctorListingByPracticeId={getDoctorListingByPracticeId}
                  watch={watch}
                  trigger={trigger}
                />
              )}
            </>
          : null}
          {/* <PracticeField
            mode="referring_and_treating_facility_4"
            shouldReset={firstReferringPractice !== referringPracticeId}
            shouldBeAbleToSearch={false}
            isAPILoading={referringPracLoading}
            control={control}
            fieldName="doctor_attributes.referring_practice_id"
            getPracticeListing={getreferringPracListing}
            pracListing={referringPracticeListing}
            setValue={setValue}
            watch={watch}
            trigger={trigger}
          /> */}
          {getValues("doctor_attributes.referring_practice_id") ?
            <DoctorField
              mode="referring_and_treating_facility_4"
              shouldReset={firstReferringDoctor !== referringDoctorId}
              control={control}
              fieldName="doctor_attributes.referring_doctor_id"
              isRequired={true}
              docListing={referringDocResponse}
              practice_id={getValues("doctor_attributes.referring_practice_id")}
              setValue={setValue}
              getDoctorListingByPracticeId={getReferringDoctorListingByPracticeId}
              watch={watch}
              trigger={trigger}
            />
          : null}
        </>
      )
      break;
    default:
      fields = <></>
  }

  return fields;
}

export default ORGUserOptions
